import { render, staticRenderFns } from "./UserEditForm.vue?vue&type=template&id=828a4fd4&scoped=true"
import script from "./UserEditForm.vue?vue&type=script&lang=js"
export * from "./UserEditForm.vue?vue&type=script&lang=js"
import style0 from "./UserEditForm.vue?vue&type=style&index=0&id=828a4fd4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "828a4fd4",
  null
  
)

export default component.exports